require('./bootstrap');

window.Vue = require('vue').default;

import Swiper from 'swiper/bundle';
// import 'swiper/css/bundle';
import { Fancybox } from '@fancyapps/ui';
import '@fancyapps/ui/dist/fancybox.css';
import Vue from 'vue';
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload);
Vue.config.devtools = true;
Vue.use(VueLazyload, {
    preLoad: 1.3,
    // error: errorimage,
    // loading: loadimage,
    attempt: 1,
});

Vue.component('cat-toggle', {
    template: `
                <li>
                    <slot name="toggle" :isOpen="isOpen" :toggleProps="toggle"></slot>
                </li>
                `,
    props: ['active'],
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
    },
    // mounted() {
    //     this.isOpen = this.active;
    // },
});

const app = new Vue({
    el: '#app',
    data: {
        mobileMenuBtn: false,
        mobilePdBtn: false,
        mobileTecBtn: false,
    },
    methods: {
        toggle() {
            this.mobileMenuBtn = !this.mobileMenuBtn;
        },
        toggleMobilePd() {
            this.mobilePdBtn = !this.mobilePdBtn;
        },
        toggleMobileTec() {
            this.mobileTecBtn = !this.mobileTecBtn;
        },
    },
});

const swiper = new Swiper('.home_swiper', {
    effect: 'fade',
    allowTouchMove: false,
    fadeEffect: {
        crossFade: true,
    },
    direction: 'vertical',
    speed: 1000,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.home_pagination',
        type: 'bullets',
        clickable: 'true',
    },
    on: {
        beforeInit: function () {
            const allBg = document.querySelectorAll('.home_bg');
            if (window.innerWidth > 768) {
                allBg.forEach(item => {
                    item.style.backgroundImage = `url('${item.dataset.pcbg}')`;
                });
            } else {
                allBg.forEach(item => {
                    item.style.backgroundImage = `url('${item.dataset.mbbg}')`;
                });
            }
        },
    },
});

const tecSwiper = new Swiper('.tec_swiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    },
    speed: 1000,
    autoplay: {
        delay: 4000,
    },
    pagination: {
        el: '.tec_pagination',
        type: 'bullets',
        clickable: 'true',
    },
});

const galleryThumbs = new Swiper('.gallery-thumbs', {
    spaceBetween: 10,
    slidesPerView: 4,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    centerInsufficientSlides: true,
    slideToClickedSlide: true,
    direction: 'vertical',
});

const galleryTop = new Swiper('.gallery-top', {
    spaceBetween: 10,
    thumbs: {
        swiper: galleryThumbs,
    },
    navigation: {
        nextEl: '.swiper_v_next',
        prevEl: '.swiper_v_prev',
        disabledClass: 'swiper_disabled',
    },
    on: {
        slideChange: function () {
            let activeIndex = this.activeIndex + 1;
            let activeSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex})`
            );
            let nextSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex + 1})`
            );
            let prevSlide = document.querySelector(
                `.gallery-thumbs .swiper-slide:nth-child(${activeIndex - 1})`
            );
            if (
                nextSlide &&
                !nextSlide.classList.contains('swiper-slide-visible')
            ) {
                this.thumbs.swiper.slideNext();
            } else if (
                prevSlide &&
                !prevSlide.classList.contains('swiper-slide-visible')
            ) {
                this.thumbs.swiper.slidePrev();
            }
        },
    },
});
